import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import PageContainer from '../../../components/PageContainer';
import { PageHeader, StatusChip } from '../../../components/ui';
import { IStore } from '../../../store/types';
import { Stories } from '../../../store/slices';
import AuthorForm from '../../../components/AuthorForm';
import StoryForm from '../../../components/StoryForm';
import GiftCadsForm from '../../../components/GiftCardsForm';
import { storyStatus } from '../../../lib/storyOptions';
import { formatDate } from '../../../lib/formatDate';
import { useStyles } from './styles';

const getID = (id) => `a${id}a`;

/** Story details: author facts, the editable story form (status, media) and the author's gift cards. */
const OneStory = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const classes = useStyles();
    const story = useSelector<IStore, any>((state) => ({ data: { ...state.stories.data[getID(id) || ''] }, status: state.stories.status }));

    useEffect(() => {
        dispatch<any>(Stories.getStory(id || ''));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const data = story.data;
    const loaded = Object.keys(data).length !== 0;
    const status = storyStatus(data.statusId);

    return (
        <PageContainer constrained>
            <PageHeader
                backTo={{ to: '/stories', label: 'Stories' }}
                eyebrow="Customer Stories"
                title={`Story #${id}`}
                badges={loaded ? (
                    <>
                        <StatusChip tone={status.tone}>{status.label}</StatusChip>
                        <StatusChip tone={data.isPublished === 1 ? 'success' : 'neutral'} dot>{data.isPublished === 1 ? 'Published' : 'Hidden'}</StatusChip>
                    </>
                ) : undefined}
                meta={loaded ? (
                    <>
                        {data.firstName && <span>By {data.firstName}</span>}
                        <span>Submitted {formatDate(data.date, { time: true })}</span>
                    </>
                ) : undefined}
            />
            {loaded ? (
                <div className={classes.stack}>
                    <AuthorForm data={story} />
                    <StoryForm data={story} />
                    <GiftCadsForm data={story} />
                </div>
            ) : (
                <div className={classes.skeletons} role="status" aria-label="Loading story">
                    <Skeleton animation="wave" variant="rounded" height={160} />
                    <Skeleton animation="wave" variant="rounded" height={420} />
                    <Skeleton animation="wave" variant="rounded" height={200} />
                </div>
            )}
        </PageContainer>
    );
};

export default OneStory;
